import { API_END_POINT, StorageKey } from "../constants";
import { ApiResult } from "../models/api-result";

export const getEndPoint = (endPoint: API_END_POINT): any => {
  let API_URL: string = "";
  console.log(process.env.REACT_APP_ADMIN_API_URL)
  switch (endPoint) {
    case API_END_POINT.ADMIN: {
      API_URL = process.env.REACT_APP_ADMIN_API_URL //"https://localhost:60949"
      break;
    }
    case API_END_POINT.MASTER: {
       API_URL = process.env.REACT_APP_MASTER_API_URL;//"https://localhost:61185";
      console.log(API_URL)
      break;
    }
    case API_END_POINT.PRODUCT: {
      API_URL =process.env.REACT_APP_PRODUCTS_API_URL;//"https://localhost:50441"; 
      break;
    }
    case API_END_POINT.PARTY: {
      API_URL = process.env.REACT_APP_PARTY_API_URL; //"https://localhost:50788";
      break;
    }
    case API_END_POINT.ORDER: {

      API_URL =  process.env.REACT_APP_ORDER_API_URL;
      break;
    }
    case API_END_POINT.REPORT: {
       API_URL =process.env.REACT_APP_REPORT_API_URL;//"https://localhost:54004";//"https://report.dev.aavinsales.com" ;   //process.env.REACT_APP_REPORT_API_URL;
      break;
    }

    

    default: {
      API_URL = process.env.REACT_APP_ADMIN_API_URL;
      console.log(API_URL);
      break;
    }
  }
  return API_URL;
};

export const getData = async <T>(
  route: string,
  endPoint: API_END_POINT,
  name?: string
): Promise<ApiResult<T>> => {
  const authState = JSON.parse(localStorage.getItem(StorageKey.AuthState));
  const requestOptions: RequestInit = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...(authState && { Authorization: `Bearer ${authState}` }),
    },
  };
  const API_BASE_URL: string = getEndPoint(endPoint);

  console.log(API_BASE_URL)
  if (API_BASE_URL) {
    console.log(`${API_BASE_URL}/api/${route}`, requestOptions);

    const result = await fetch(`${API_BASE_URL}/api/${route}`, requestOptions);

    return {
      name,
      status: result.status,
      data: await result.json(),
    };
  } else {
    console.log("URL not specified in get", API_BASE_URL);
  }
};

export const postData = async <T>(
  endPoint: API_END_POINT,
  route: string,
  method: string,
  contentType: string,
  data: any
): Promise<ApiResult<T>> => {
  const authState = JSON.parse(localStorage.getItem(StorageKey.AuthState));
  const unionId  = JSON.parse(localStorage.getItem(StorageKey.AuthState));
  const authUnion  = JSON.parse(localStorage.getItem(StorageKey.AuthState));

  const submitData =
    contentType === "application/json" ? JSON.stringify(data) : data;
  const skipContentType = contentType === "multipart/form-data";
  const requestOptions: RequestInit = {
    method: method,
    headers: {
      ...(!skipContentType && { "Content-Type": contentType }),
      ...(authState && { Authorization: `Bearer ${authState}` }),
    },
    body: submitData,
  };
  if (!JSON.stringify(submitData).includes("email")) {
    console.log(submitData);
  }
  const API_BASE_URL: string = getEndPoint(endPoint);
  if (API_BASE_URL) {
    const result = await fetch(`${API_BASE_URL}/api/${route}`, requestOptions);
    return {
      status: result.status,
      data: await result.json(),
    };
  } else {
    console.log("URL not specified in POST", API_BASE_URL);
  }
};

export const getDataWithToken = async <T>(
  url: string
): Promise<ApiResult<T>> => {
  const authState = JSON.parse(localStorage.getItem(StorageKey.AuthState));
  const requestOptions: RequestInit = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...(authState && { Authorization: `Bearer ${authState}` }),
    },
  };
  const API_BASE_URL: string = url;
  
  if (API_BASE_URL) {
    console.log(API_BASE_URL, requestOptions);
    const result = await fetch(API_BASE_URL, requestOptions);
    return {
      status: result.status,
      data: await result.json(),
    };
  } else {
    console.log("URL not specified in get", API_BASE_URL);
  }
};

export const getPDFWithToken = async (url: string): Promise<Blob> => {
  const authState = JSON.parse(localStorage.getItem(StorageKey.AuthState));
  const requestOptions: RequestInit = {
      method: "GET",
      headers: {
          ...(authState && { Authorization: `Bearer ${authState}` }),
      },
  };

  const API_BASE_URL: string = url;
  console.log(API_BASE_URL);

  if (API_BASE_URL) {
      console.log(API_BASE_URL, requestOptions);
      const result = await fetch(API_BASE_URL, requestOptions);

      if (!result.ok) {
          throw new Error(`Error fetching PDF: ${result.statusText}`);
      }

      return await result.blob(); 
  } else {
      console.error("URL not specified in get", API_BASE_URL);
      throw new Error("URL not specified");
  }
};

export const getHtmlWithToken = async (url: string): Promise<string> => {
  const authState = JSON.parse(localStorage.getItem(StorageKey.AuthState));
  const requestOptions: RequestInit = {
      method: "GET",
      headers: {
          ...(authState && { Authorization: `Bearer ${authState}` }),
          "Content-Type": "application/json",
      },
  };

  const result = await fetch(url, requestOptions);

  if (!result.ok) {
      throw new Error(`Error fetching HTML: ${result.statusText}`);
  }

  // Parse JSON response
  const responseData = await result.json();

  // Extract only the HTML content
  if (responseData && responseData.result) {
      return responseData.result; 
  } else {
      throw new Error("Invalid response format: Missing 'result' field");
  }
};